import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { AppShell } from "@/components/AppShell";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import ImportCenter from "@/pages/ImportCenter";
import FinalSheets from "@/pages/FinalSheets";
import Results from "@/pages/Results";
import Program from "@/pages/Program";
import Subscribe from "@/pages/Subscribe";
import Promos from "@/pages/Promos";
import MatrixImpact from "@/pages/MatrixImpact";
import { PaymentSuccess, PaymentCancel } from "@/pages/Payment";
import { AccessGate } from "@/components/AccessGate";
import RaceDetail from "@/pages/RaceDetail";
import Settings from "@/pages/Settings";
import Contact from "@/pages/Contact";
import Terms from "@/pages/Terms";
import ForgotPassword from "@/pages/ForgotPassword";

const Protected = ({ children }) => {
  const { user } = useAuth();
  if (user === null)
    return (
      <div className="min-h-screen grid place-items-center" data-testid="auth-loading">
        <div className="loader-bar" />
      </div>
    );
  if (!user) return <Navigate to="/" replace />;
  return children;
};

const AdminOnly = ({ children }) => {
  const { user } = useAuth();
  return user?.role === "admin" ? children : <Navigate to="/program" replace />;
};

const PublicOnly = ({ children }) => {
  const { user } = useAuth();
  if (user) return <Navigate to="/program" replace />;
  return children;
};

function App() {
  useEffect(() => { document.title = "Strategic Ratings"; }, []);
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/forgot-password" element={<PublicOnly><ForgotPassword /></PublicOnly>} />
          <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
          <Route element={<Protected><AccessGate><AppShell /></AccessGate></Protected>}>
            <Route path="/subscribe" element={<Subscribe />} />
            <Route path="/payment/success" element={<PaymentSuccess />} />
            <Route path="/payment/cancel" element={<PaymentCancel />} />
            <Route path="/program" element={<Program />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/import" element={<AdminOnly><ImportCenter /></AdminOnly>} />
            <Route path="/race/:id" element={<AdminOnly><RaceDetail /></AdminOnly>} />
            <Route path="/sheets" element={<AdminOnly><FinalSheets /></AdminOnly>} />
            <Route path="/results" element={<Results />} />
            <Route path="/settings" element={<AdminOnly><Settings /></AdminOnly>} />
            <Route path="/promos" element={<Promos />} />
            <Route path="/matrix-impact" element={<AdminOnly><MatrixImpact /></AdminOnly>} />
          </Route>
          <Route path="*" element={<Navigate to="/program" replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster theme="dark" position="bottom-right" richColors />
    </AuthProvider>
  );
}

export default App;
